import { Component, OnInit, NgZone } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
  inputs = {
    displayName: {
      isFocused: false,
      inputValue: '',
    },
    email: {
      isFocused: false,
      inputValue: '',
    },
    password: {
      isFocused: false,
      inputValue: '',
    },
    privacy: true,
    updates: true,
  };
  signupError = '';

  constructor(
    private userService: UserService,
    private router: Router,
    private zone: NgZone,
    private loadingService: LoadingService,
    private analyticsService: AnalyticsService,
    private notificationService: NotificationsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('signup_view');
  }

  signup(): void {
    if (!!this.inputs.displayName.inputValue.split(' ')[1]) {
      this.signupError = '';
      this.loadingService.startLoading();
      this.userService
        .signup(this.inputs.displayName.inputValue, this.inputs.email.inputValue, this.inputs.password.inputValue, this.inputs.updates)
        .then((tm: any) => {
          /*
          this.notificationService.sendNotifications({
            type: 'welcomeEmail',
            email: this.inputs.email.inputValue,
            displayName: this.inputs.displayName.inputValue
          });
          */
          this.analyticsService.event('signup_success');
          this.zone.run(async () => {
            await this.router.navigateByUrl('/').then(() => {
              this.loadingService.stopLoading();
            });
          });
        })
        .catch((err) => {
          console.error(err);
          this.loadingService.stopLoading();
          this.signupError = err;
        });
    } else {
      alert('Please enter your full name, or add a last initial.');
    }
  }
}
